import type from './bookmark.types'

export const addError = (errors, action) => {
  const errorId = errors.data.findIndex(
    error => error.name === action.payload.name
  )

  errors.current = action.payload

  if (errorId === -1) errors.data.push(action.payload)
  else errors.data[errorId] = action.payload

  return errors
}

export const updateBookmark = (list, errors, action) => {
  const updateBookmarkId = list.findIndex(user => user.id === action.payload.id)
  if (updateBookmarkId === -1)
    errors.push({
      name: type.UPDATE_BOOKMARK,
      error: `${updateBookmarkId} don't exist`,
    })
  else list[updateBookmarkId] = action.payload
  return { list, errors }
}
